<template>
    <v-dialog
        v-model="isOpen"
        max-width="600"
    >
        <v-card class="py-3 px-5">
            <v-form ref="form" v-model="valid">
                <v-text-field
                    :rules="[value => !!value || 'Required.']"
                    label="Label"
                    required
                    v-model="item.label"
                />
            </v-form>
            <v-card-actions>
                <v-btn 
                    class="mr-3" 
                    outlined 
                    color="primary darken-1"
                    @click="handleCancel"
                >
                    Cancel
                </v-btn>
                <v-btn 
                    class="white--text" 
                    color="primary darken-1"
                    @click="handleSave"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { generateUUID } from '../../helpers/utilities';

    export default {
        name: 'ProjectStepDetails',

        props: {
            item: {
                type: Object,
                required: true,
                default: {}
            },
            value: {
                type: Boolean,
                default: false
            }
        },

        data: () => ({
            valid: false,
            isOpen: false
        }),
    
        watch: {
            value(newValue) {
                this.isOpen = newValue
                if (newValue) {
                    // When the dialog opens, ensure item.name has a UUID if not already set
                    if (!this.item.name || this.item.name === '') {
                        this.$set(this.item, 'name', generateUUID());
                    }
                }
            },
            isOpen(newValue) {
                // Sync the internal state back to parent via v-model
                if (newValue !== this.value) {
                    this.$emit('input', newValue)
                }
            }
        },

        methods: {
            handleCancel: function () {
                this.$emit('input', false)
            },
            
            handleSave: async function () {
                this.valid = this.$refs.form.validate()

                if (this.valid) {
                    this.$emit('save', this.item);
                    this.$emit('input', false);
                }
            }
        }
    }
    
</script>


// WEBPACK FOOTER //
// src/components/datamanagement/ProjectStepDetails.vue